export const MAXIMUM_PAGE_SIZE = 25;

export const MAX_LOANS_PAGE_SIZE = 40;
